import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Grapesjs from 'grapesjs'

import { useUpdateCall } from '../../../lib/api/update'
import dynamicConfig from './grapesjsConfigFoot'

import 'grapesjs/dist/css/grapes.min.css'
import './app.css'
import './templates.css'
import './templateSlider.css'

const FooterEditor = ({ allData, envData, authDetails, isLocalEnvironment }) => {
  const [editor] = useState({})
  const [edtrAssets] = useState(JSON.parse(localStorage.getItem('builderAssets')))
  const queryParams = new URLSearchParams(window.location.search)
  const projectId = queryParams.get('project')
  const notPublished = queryParams.get('notPublished')
  const thmId = queryParams.get('themeId')
  const updateCallMutation = useUpdateCall()
  const loadTheme = allData?.projects?.filter((f) => f.websiteProjectId === projectId) || []
  const webSettings = loadTheme.length > 0 ? JSON.parse(loadTheme[0].websiteProjectSettings) : null
  setTimeout(() => {
    const gjsFrame = document.getElementsByClassName('gjs-frame')
    gjsFrame[0].contentWindow.document.documentElement.style.setProperty(
      '--primaryColor',
      webSettings.primaryColor,
    )
    gjsFrame[0].contentWindow.document.documentElement.style.setProperty(
      '--primaryHoverColor',
      webSettings.primaryHoverColor,
    )
    gjsFrame[0].contentWindow.document.documentElement.style.setProperty(
      '--secondaryColor',
      webSettings.secondaryColor,
    )
    gjsFrame[0].contentWindow.document.documentElement.style.setProperty(
      '--secondaryHoverColor',
      webSettings.secondaryHoverColor,
    )
    gjsFrame[0].contentWindow.document.documentElement.style.setProperty(
      '--lightColor',
      webSettings.lightColor,
    )
    gjsFrame[0].contentWindow.document.documentElement.style.setProperty(
      '--darkColor',
      webSettings.darkColor,
    )
  }, 1000)

  let edtr
  useEffect(() => {
    loadGrapesJs()
    const unloadCallback = (event) => {
      event.preventDefault()
      event.returnValue = ''
      return ''
    }

    window.addEventListener('beforeunload', unloadCallback)
    return () => window.removeEventListener('beforeunload', unloadCallback)
  }, [editor])

  function newCopy(selected) {
    window.sessionStorage.setItem('grapesjs_clipboard', JSON.stringify(selected))
  }
  function newPaste(selected) {
    var components = JSON.parse(window.sessionStorage.getItem('grapesjs_clipboard'))

    if (components) {
      if (selected && selected.attributes.type !== 'wrapper') {
        var index = selected.index()
        // Invert the order so last item gets added first and gets pushed down as others get added.
        components.reverse()
        var currentSelection = selected.collection
        components.forEach((comp) => {
          // TODO: Add check for validity of paste.
          var added = currentSelection.add(comp, { at: index + 1 })
          editor.trigger('component:paste', added)
        })
        selected.emitUpdate()
      } else {
        // No components are selected so just insert at the end.
        editor.addComponents(`${components}`)
      }
    }
    window.sessionStorage.removeItem('grapesjs_clipboard')
  }

  const addCommands = (editor) => {
    const commands = editor.Commands
    commands.getAll()
    commands.add('set-device-xs', {
      run(editor) {
        editor.setDevice('Mobile')
      },
    })
    commands.add('set-device-sm', {
      run(editor) {
        editor.setDevice('Tablet')
      },
    })
    commands.add('set-device-xl', {
      run(editor) {
        editor.setDevice('Desktop')
      },
    })
    commands.add('open-assset-manager', {
      run(editor) {
        const myCommands = commands.get('core:open-assets')
        myCommands.run(editor, { target: '_blank' })
      },
    })
    commands.add('core:copy', (editor) => {
      const selected = [...editor.getSelectedAll()]
      //Filter out components that are not copyable.
      var filteredSelected = selected.filter((item) => item.attributes.copyable == true)
      if (filteredSelected.length) {
        newCopy(filteredSelected)
      }
    })
    commands.add('core:paste', (editor) => {
      const selected = editor.getSelected()
      newPaste(selected)
    })
    editor.on('run:preview', () => {
      editor.stopCommand('sw-visibility')
      document.getElementById('blocks').style.display = 'none'
      document.getElementById('rightPanel').style.display = 'none'
      document.getElementById('gjs').style.padding = '0px'
      document.getElementsByClassName('gjs-off-prv')[0].style.display = 'none'
      document.getElementById('saveCode').style.display = 'none'
      document.getElementById('rightPanel').style.zIndex = -100
    })
    editor.on('stop:preview', () => {
      editor.runCommand('sw-visibility')
      document.getElementById('blocks').style.display = 'block'
      document.getElementById('rightPanel').style.display = 'block'
      document.getElementById('gjs').style.padding = '0.5rem'
      document.getElementById('saveCode').style.display = 'block'
      document.getElementById('rightPanel').style.zIndex = 100
    })
    editor.on('asset:upload:response', (response) => {
      const newImg = response.formData.formData
        ? response.formData.formData.fileUrl.replace('%2F', '/')
        : response.formData.fileUrl.replace('%2F', '/')
      const allAssets = [newImg, ...edtrAssets]
      editor.AssetManager.add(allAssets)
      localStorage.setItem('builderAssets', JSON.stringify(allAssets))
    })
  }

  const loadGrapesJs = async () => {
    const editor = await Grapesjs.init(
      dynamicConfig(
        allData,
        projectId,
        notPublished,
        thmId,
        edtrAssets,
        envData,
        authDetails,
        isLocalEnvironment,
      ),
    )
    addCommands(editor)
    onLoad(editor)
    edtr = editor
    const categories = editor.BlockManager.getCategories()
    categories.each((category) => {
      category.set('open', false).on('change:open', (opened) => {
        opened.get('open') &&
          categories.each((category) => {
            category !== opened && category.set('open', false)
          })
      })
    })
  }
  const onLoad = () => {}

  const updatePage = async () => {
    const currentFooter = { websiteProjectFooter: edtr.getHtml() }
    const replacebody = currentFooter.websiteProjectFooter.replace('<body>', '')
    const data = replacebody.replace('</body>', '')
    const footerData = { websiteProjectFooter: data }
    await updateCallMutation.mutateAsync({
      url: isLocalEnvironment + '/updateData',
      apiEndpoint: 'websiteProjects',
      data: footerData,
      id: projectId,
      messageTitle: 'Website',
      message: 'Footer updated!',
      params: `&targetTenantId=${authDetails.session.user.appAdmin.tenantId}&targetAppId=${authDetails.session.user.appAdmin.appId}&targetOrgId=${authDetails.session.user.appAdmin.orgId}`,
      isDynamic: true,
    })
    window.location.reload()
  }
  document.documentElement.style.setProperty('--primaryColor', webSettings?.primaryColor || '')
  return (
    <div>
      <div className="panel__top">
        <div className="panel__switcher"></div>
        <div className="gjs-panel-action-buttons">
          <div className="views-actions" style={{ position: 'static' }} id="mediaQuery"></div>
        </div>
        <div className="panel-action">
          <button
            className="btn btn-primary"
            id="saveCode"
            disabled={updateCallMutation.isLoading ? true : false}
            onClick={updatePage}
          >
            {updateCallMutation.isLoading ? 'Saving...' : 'Save Footer'}
          </button>
        </div>
      </div>
      <div className="editor-row ml-4">
        <div id="blocks"></div>
        <div className="editor-canvas">
          <div id="gjs" />
        </div>
        <div className="panel__right" id="rightPanel">
          <div id="traits-container" style={{ direction: 'ltr' }} />
          <div className="layers-container" style={{ direction: 'ltr' }} />
          <div id="stylesContainer" className="styles-container" style={{ direction: 'ltr' }} />
        </div>
      </div>
    </div>
  )
}

export default FooterEditor

FooterEditor.propTypes = {
  allData: PropTypes.object.isRequired,
  envData: PropTypes.object.isRequired,
  authDetails: PropTypes.object.isRequired,
  isLocalEnvironment: PropTypes.string.isRequired,
}
